import { Component, Input, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { AlertService } from '../alert/alert.service';
import { GermplasmListService } from '../germplasm-list/service/germplasm-list.service';
import { ListBuilderContext } from '../list-builder/list-builder.context';
import { JhiEventManager } from '../core-utils';

@Component({
    selector: 'jhi-germplasm-list-builder-reorder-entries-dialog',
    templateUrl: './germplasm-list-reorder-entries-dialog.component.html'
})
export class GermplasmListBuilderReorderEntriesDialogComponent implements OnInit {
    static readonly LIST_BUILDER_REORDER_EVENT_SUFFIX = 'ListBuilderReordered';

    @Input() selectedEntries: number[];

    position: Position;
    fixedPosition: number;

    isLoading: boolean;

    Position = Position;

    constructor(private modal: NgbActiveModal,
                private alertService: AlertService,
                private activeModal: NgbActiveModal,
                private activatedRoute: ActivatedRoute,
                private germplasmListService: GermplasmListService,
                private eventManager: JhiEventManager,
                private context: ListBuilderContext) {
        this.isLoading = false;
    }

    ngOnInit(): void {
    }

    closeModal() {
        this.activeModal.dismiss();
    }

    reorder() {
        this.isLoading = true;
        if (this.validatePosition()) {
            const reorderedData = [];
            switch (this.position) {
            case Position.START:
                this.context.data.forEach((entry) => {
                    if (this.selectedEntries.includes(entry.internal_id)) {
                        reorderedData.push(entry);
                    }
                });
                this.context.data.forEach((entry) => {
                    if (!this.selectedEntries.includes(entry.internal_id)) {
                        reorderedData.push(entry);
                    }
                });
                break;
            case Position.END:
                this.context.data.forEach((entry) => {
                    if (!this.selectedEntries.includes(entry.internal_id)) {
                        reorderedData.push(entry);
                    }
                });
                this.context.data.forEach((entry) => {
                    if (this.selectedEntries.includes(entry.internal_id)) {
                        reorderedData.push(entry);
                    }
                });
                break;
            case Position.FIXED:
                let entryNo = 1;
                this.context.data.forEach((entry) => {
                    if (Number(entryNo) === Number(this.fixedPosition)) {
                        this.context.data.forEach((listEntry) => {
                            if (this.selectedEntries.includes(listEntry.internal_id)) {
                                reorderedData.push(listEntry);
                                entryNo++;
                            }
                        });
                    }
                    if (!this.selectedEntries.includes(entry.internal_id)) {
                        reorderedData.push(entry);
                        entryNo++;
                    }
                });
                break;
            }
            this.context.data = reorderedData;
            this.eventManager.broadcast({
                name: GermplasmListBuilderReorderEntriesDialogComponent.LIST_BUILDER_REORDER_EVENT_SUFFIX,
                content: ''
            });
            this.modal.close();
        }
    }

    validatePosition() {
        if (this.position === Position.FIXED) {
            const maxPossiblePos = this.context.data.length - this.selectedEntries.length + 1;
            if (this.fixedPosition <= 0 || this.fixedPosition > maxPossiblePos) {
                this.alertService.error('list-builder.invalid.selected.position.number',
                    { param1: this.fixedPosition, param2: this.context.data.length, param3: maxPossiblePos });
                this.isLoading = false;
                return false;
            }
        }
        return true;
    }

    isFormValid(f) {
        return f.form.valid && !this.isLoading && this.position;
    }
}

enum Position {
    START = 'START',
    END = 'END',
    FIXED = 'FIXED'
}
